import React from 'react';

/**
 * Shared PSB / delivery-document evidence pills (backend
 * services/match_comparison_contract). Brand, Variant and Pack Size only —
 * agree must be supported by evidence; 'unknown' is never agreement.
 * Hover/tap a pill for source vs Product Master values and the reason.
 */
const PILL_ORDER = ['brand', 'variant', 'pack_size'];
const PILL_LABELS = { brand: 'Brand', variant: 'Variant', pack_size: 'Pack Size' };
const STATE_STYLE = {
  agree: 'bg-emerald-50 text-emerald-700 border-emerald-300',
  conflict: 'bg-rose-50 text-rose-700 border-rose-300',
  unknown: 'bg-slate-50 text-slate-500 border-slate-200',
};
const STATE_SYMBOL = { agree: '\u2713', conflict: '\u2715', unknown: '?' };
const fmt = (v) => (Array.isArray(v) ? v.join(', ') : v) || '(none)';

function pillTitle(label, pill) {
  let t = `${label} — Source: ${fmt(pill.source_value)} | Product Master: ${fmt(pill.master_value)} — ${pill.reason}`;
  const d = pill.details;
  if (d) {
    ['item_volume', 'purchase_count', 'form'].forEach((k) => {
      if (d[k]) t += `\n• ${k.replace('_', ' ')}: ${d[k].state} — ${d[k].reason}`;
    });
  }
  return t;
}

export function EvidencePillRow({ pills, loading, testIdPrefix }) {
  if (loading) {
    return <div className="text-[10px] text-muted-foreground" data-testid={`${testIdPrefix}-loading`}>Checking evidence…</div>;
  }
  if (!pills) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-1" data-testid={testIdPrefix}>
      {PILL_ORDER.map((key) => {
        const pill = pills[key];
        if (!pill) return null;
        const state = STATE_STYLE[pill.state] ? pill.state : 'unknown';
        return (
          <span
            key={key}
            title={pillTitle(PILL_LABELS[key], pill)}
            className={`inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px] font-medium cursor-help ${STATE_STYLE[state]}`}
            data-testid={`${testIdPrefix}-${key}-${state}`}
          >
            <span>{STATE_SYMBOL[state]}</span>
            {PILL_LABELS[key]}
          </span>
        );
      })}
    </div>
  );
}

export default EvidencePillRow;
